var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payroll-report',{attrs:{"userIdProp":_vm.targetUser.user_id,"isAdminProp":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }